import { render, staticRenderFns } from "./apiTable.vue?vue&type=template&id=5da0abe5&"
import script from "./apiTable.vue?vue&type=script&lang=js&"
export * from "./apiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports